var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canDelete && _vm.$auth.isDev())?_c('v-btn',{attrs:{"color":"red","small":"","outline":"","disabled":_vm.$auth.isCust()},on:{"click":_vm.destroy}},[_vm._v("\n       "+_vm._s(_vm.$t('delete'))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }